import type { AnfrageStatus } from '@/lib/api';

/*
 * Diagrammfarben der Anfrage-Status in Reihenfolge der Spalten (chart-1 bis
 * chart-5). Text und Ton der Status kommen aus STATUS von @elbklar/ui:
 * <Status status={anfrage.status} />.
 */
export const ANFRAGE_STATUS_CHART: Record<AnfrageStatus, string> = {
  NEU: 'var(--chart-1)',
  IN_BEARBEITUNG: 'var(--chart-2)',
  IN_PLANUNG: 'var(--chart-3)',
  GEWONNEN: 'var(--chart-4)',
  VERLOREN: 'var(--chart-5)',
};
